import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../dialog-component/dialog-component.component';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';

@Component({
  selector: 'home-component',
  templateUrl: './home-component.component.html',
  styleUrls: ['./home-component.component.scss'],
})
export class HomeComponent {
  isLoading = false;
  dateFormGroup: FormGroup;
  radioFormGroup: FormGroup;
  invoiceNumber: FormControl;
  customerNumber: FormControl;
  pinNumber: FormControl;
  manifestNumber: FormControl;
  pinSearchCheckbox: FormControl;
  disabledInvoiceInput:boolean=true;
  showPinCheckbox: boolean = false;
  next_token: string | null = null;

  pinNumberByImage: FormControl;
  emptyTableData:boolean=false;
  searchFormValidation: boolean;
  searchByImageFormValidation: boolean;
  dateRequiredValidation:boolean=false;
  requiredFieldValidation:boolean=false;
  dataSource: {
    customerAccount: string;
    invoiceNumber: string;
    invoiceDate: string;
    invoiceAmount: string;
    invoicePdf: string;
  }[] = [];
  isDataCompleted: FormControl;
  pinNumberValidation:boolean=false;
  pinNumberImageValidation:boolean=false;
  invoiceNumberFormatValidation: boolean=false;
  customerNumberFormatValidation:boolean=false;
  popUpValue: any;
  constructor(
    public dialog: MatDialog,
    private invoiceService: InvoiceService,
    private fb: FormBuilder
  ) {
    this.dateFormGroup = new FormGroup(
      {
        fromDate: new FormControl(
          new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 3,
            new Date().getDate()
          ),Validators.required
        ),
        toDate: new FormControl(new Date(),[Validators.required]),
      },
      [Validators.required, this.dateRangeValidator]
    );
    this.radioFormGroup = new FormGroup({ options: new FormControl('') }, [
      Validators.required,
    ]);

    this.invoiceNumber = new FormControl('',[Validators.pattern('^[0-9,-]+$')]);
    this.customerNumber = new FormControl('',[Validators.pattern('[a-zA-Z0-9,-]+$')]);
    this.pinNumber = new FormControl('');
    this.manifestNumber = new FormControl('');
    this.pinNumberByImage = new FormControl('');
    this.searchFormValidation = true;
    this.searchByImageFormValidation = true;
    this.isDataCompleted = new FormControl('');
    this.pinSearchCheckbox = new FormControl(false)
  }




  public invoiceNumberValidation(){

    this.dateRequiredValidation=false;
    this.requiredFieldValidation=false;

    let regex=/^[0-9,-]+$/;
    if(regex.test(this.invoiceNumber.value)){
      this.invoiceNumberFormatValidation=false;
    }else{
      if(this.invoiceNumber.value!='')
      this.invoiceNumberFormatValidation=true;
    }

    if(this.invoiceNumber.value==''){
      this.invoiceNumberFormatValidation=false
    }
  }
  public customerNumberValidation(){
    this.dateRequiredValidation=false;
    this.requiredFieldValidation=false;
    let regex=/^[a-zA-Z0-9,-]+$/;
    if(regex.test(this.customerNumber.value)){
      this.customerNumberFormatValidation=false;
    }else{
      if(this.customerNumber.value!='')
      this.customerNumberFormatValidation=true;
    }
    if(this.customerNumber.value==''){
      this.customerNumberFormatValidation=false;
    }
  }

  public onPinChange(){
    this.requiredFieldValidation=false;
    let regex=/^[a-zA-Z0-9,-]+$/;
    if(this.pinNumber.value==''){
      this.pinNumberValidation=false;
    }
    if(this.pinNumber.value.length<6 && this.pinNumber.value!='' && !regex.test(this.pinNumber.value)){
      this.pinNumberValidation=true;
    }else{
      this.pinNumberValidation=false;
    }
    this.showPinCheckbox = this.pinNumber.value.includes('-');
  }

  public onPinNumberChange(){
    let regex=/^[a-zA-Z0-9,-]+$/;
    if(this.pinNumberByImage.value==''){
      this.pinNumberImageValidation=false;
    }
    if(this.pinNumberByImage.value.length<6 && this.pinNumberByImage.value!='' && !regex.test(this.pinNumberByImage.value)){
      this.pinNumberImageValidation=true;
    }else{
      this.pinNumberImageValidation=false;
    }

  }

  dateValidation() {
    let invalidFlag = false;
    const fromDate = this.dateFormGroup?.get('fromDate')?.value;
    const toDate = this.dateFormGroup?.get('toDate')?.value;

    if (fromDate && toDate) {
      invalidFlag = new Date(fromDate).valueOf() > new Date(toDate).valueOf();
    }
    return { invalidFlag, fromDate, toDate };
  }

  todayDate = new Date();

  getFromDate() {
    const { fromDate } = this.dateValidation();
    return fromDate;
  }

  private dateRangeValidator: ValidatorFn = (): { [key: string]: any } | null => {
    const fromDate = this.dateFormGroup?.get('fromDate')?.value;
    const toDate = this.dateFormGroup?.get('toDate')?.value;

    if (fromDate && toDate) {
      const oneYearInMs = 365 * 24 * 60 * 60 * 1000;
      const dateDifference = new Date(toDate).getTime() - new Date(fromDate).getTime();

      if (dateDifference > oneYearInMs) {
        return { dateRangeExceedsOneYear: true };
      }
    }
    return null;
  };



  getSearchFormValidation() {
    const { invalidFlag, fromDate, toDate } = this.dateValidation();
    this.searchFormValidation =
      (!invalidFlag && fromDate && toDate) ||
      this.invoiceNumber.value ||
      this.customerNumber.value ||
      this.pinNumber.value ||
      this.pinNumberByImage.value ||
      this.manifestNumber.value ||
      this.isDataCompleted.value || this.pinSearchCheckbox.value;

    if (this.customerNumber.value || this.pinNumber.value) {
      this.searchFormValidation = !invalidFlag && fromDate && toDate;
    }
  }

  clearDate() {
    this.dateRequiredValidation=false;

    this.dateFormGroup.setValue({ fromDate: null, toDate: null });
  }

  clearInput() {
    this.invoiceNumber.setValue('');
    this.customerNumber.setValue('');
    this.pinNumber.setValue('');
    this.manifestNumber.setValue('');
    this.emptyTableData=false;
    this.dataSource = [];
    this.dateRequiredValidation=false;
    this.pinNumberValidation=false;
    this.customerNumberFormatValidation=false;
    this.invoiceNumberFormatValidation=false;
    this.requiredFieldValidation=false;
  }

  clearInputByImage() {
    this.pinNumberByImage.setValue('');
    this.radioFormGroup.setValue({ options: '' });
    this.searchByImageFormValidation=true;
    this.isDataCompleted.reset();
    this.emptyTableData=false;
  }

  invoiceSearch() {
    this.getSearchFormValidation();
    const { invalidFlag, fromDate, toDate } = this.dateValidation();
    return {
      customer_number: this.customerNumber.value?.trim(),
      invoice_number: this.invoiceNumber.value?.trim(),
      start_date: new Date(fromDate).toLocaleDateString('en-CA').replace(/-/g, ''),
      end_date: new Date(toDate).toLocaleDateString('en-CA').replace(/-/g, ''),
      pin: this.pinNumber.value?.trim(),
      pin_search: this.showPinCheckbox ? this.pinSearchCheckbox.value : false,
      imgPin: '',
      manifest: '',
      isDataCompleted: '',
      next_token: this.next_token
    };
  }

  imageSearch() {
    return {
      customer_number: '',
      invoice_number: '',
      date: '',
      pin: '',
      imgPin: this.pinNumberByImage.value,
      manifest: '',
      isDataCompleted: this.isDataCompleted.value,
    };
  }
  validateSearchFeild(){
    if((this.dateFormGroup.get('fromDate')?.value!=null || this.dateFormGroup.get('toDate')?.value!=null)&&
    (this.invoiceNumber &&this.invoiceNumber?.value=='') || (this.customerNumber&& this.customerNumber?.value=='')||
    (this.pinNumber&&this.pinNumber?.value=='')){
      if(this.invoiceNumber && this.invoiceNumber?.value!=''){
        this.requiredFieldValidation=false;
      }
      else if(this.customerNumber && this.customerNumber?.value!=''){
        this.requiredFieldValidation=false;
      }else if(this.pinNumber && this.pinNumber?.value!=''){
        this.requiredFieldValidation=false;
      }else{
        this.requiredFieldValidation=true;
      }
    }
    return this.requiredFieldValidation;
  }

  searchResults(searchType: string, imageSearch: boolean) {
    this.dataSource = [];
    this.next_token = ''
    if (imageSearch && (!this.dateFormGroup.get('fromDate')?.value || !this.dateFormGroup.get('toDate')?.value)) {
      this.dateRequiredValidation = true;
    } else if (imageSearch && this.validateSearchFeild()) {
      this.requiredFieldValidation = true;
    } else {
      this.isLoading = true;
      this.dateRequiredValidation = false;
  
      let params: any;
  
      if (searchType === 'invoice') {
        params = this.invoiceSearch();
        if (!params) {
          return;
        }
      } else {
        params = this.imageSearch();
      }
  
      this.invoiceService.getInvoice(params).subscribe({
        next: (data) => {
          let parsedData;
          if (searchType === 'invoice') {
            parsedData = JSON.parse(data);
            const items = parsedData['items'] || [];
            if (items.length === 0) {
              this.emptyTableData = true;
            } else {
              this.emptyTableData = false;
            }
            this.next_token = parsedData['next_token'] || null;
            this.dataSource = [
              ...this.dataSource,
              ...items.map((elem: any) => ({
                customerAccount: elem['account_number']['S'],
                invoiceNumber: elem['invoice_number']['S'],
                invoiceDate: elem['date']['N'],
                invoiceAmount: elem['invoice_amt']['S'],
                invoicePdf: elem['bucket_url']['S'],
              })),
            ];
          } else if (data === 'No Data Found') {
            this.emptyTableData = true;
          } else {
            this.emptyTableData = false;
            window.open(data.replace(' ', ''));
          }
          this.isLoading = false;
        },
        error: (err) => {
          this.isLoading = false;
          console.error(err);
        },
      });
    }
  } 
  loadNextPage(nextToken: string) {
    this.isLoading = true;
    if (!nextToken) {
      return;
    }
    let params: any;
    params = this.invoiceSearch();
    params['next_token'] = nextToken;
    this.invoiceService.getInvoice(params).subscribe({
      next: (response) => {
        this.isLoading = false;
        const parsedData = JSON.parse(response);
        const items = parsedData['items'] || [];
        this.dataSource = [
          ...this.dataSource,
          ...items.map((elem: any) => ({
            customerAccount: elem['account_number']['S'],
            invoiceNumber: elem['invoice_number']['S'],
            invoiceDate: elem['date']['N'],
            invoiceAmount: elem['invoice_amt']['S'],
            invoicePdf: elem['bucket_url']['S'],
          })),
        ];
        this.dataSource = Array.from(
          new Map(this.dataSource.map(item => [item.invoiceNumber, item])).values()
        );
        this.next_token = parsedData['next_token'] || null;
        if (items.length === 0) {
          this.isLoading = false;
          this.emptyTableData = true;
        } else {
          this.isLoading = false;
          this.emptyTableData = false;
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Next Page Error', err);
      }
    });
  }

  searchByImageResults() {
    const controlOption = this.isDataCompleted?.value;
    if (controlOption && this.pinNumberByImage.value) {
      this.searchResults('image', false);
      this.searchByImageFormValidation = true;
    } else {
      this.searchByImageFormValidation = false;
    }
  }

  openDialog(type: string) {
    const dialog = this.dialog.open(DialogComponent, {
      disableClose: true,
      data: type,
    });
  
    dialog.afterClosed().subscribe((res) => {
      if (res?.event) {
        if (res.event === 'range') {
          this.popUpValue = res.data.map((item: any) => `${item.from}-${item.to}`).join(', ');
        } else {
          this.popUpValue = res.data.map((item: any) => `${item.invoice}`).join(',');
        }
  
        this.setValueBasedOnType(res.type);
        this.onPinChange()
      }
    });
  }
  
  setValueBasedOnType(type: string) {
    let control: FormControl | undefined;
    let valueToSet: string;
  
    switch (type) {
      case 'invoiceNo':
        control = this.invoiceNumber;
        break;
      case 'cutomerNo':
        control = this.customerNumber;
        break;
      case 'pin':
        control = this.pinNumber;
        break;
      case 'imagePin':
        control = this.pinNumberByImage;
        break;
      default:
        return;
    }
  
    valueToSet = this.popUpValue.length > 0 ? this.popUpValue : '';
  
    if (control) {
      control.setValue(valueToSet);
    }
  }  
}